import { render, staticRenderFns } from "./DiscloseJob.vue?vue&type=template&id=15c4d606&scoped=true&"
import script from "./DiscloseJob.vue?vue&type=script&lang=js&"
export * from "./DiscloseJob.vue?vue&type=script&lang=js&"
import style0 from "./DiscloseJob.vue?vue&type=style&index=0&id=15c4d606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c4d606",
  null
  
)

export default component.exports